import store from '../../store/store';
import { API } from '@aws-amplify/api';

export default {
  get(path, params = {}) {
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) {
        delete params[key];
      }
      // Page comes as object page: { size: 200 }, need to make "page[size]" = 200
      if (typeof params[key] === 'object' && params[key] !== null) {
        Object.keys(params[key]).forEach(i => {
          params[`${key}[${i}]`] = params[key][i];
        });
        delete params[key];
      }
    });

    return API
      .get('CDS-API', `/${path}`, { queryStringParameters: { sku: store.getters.currentProductSKU, ...params } });
  },
  put(path, body = {}) {
    return API
      .put('CDS-API', `/${path}`, { body });
  },
  post(path, body = {}, headers = {}) {
    return API
      .post('CDS-API', `/${path}`, { body, headers });
  },
  patch(path, body = {}, headers = {}) {
    return API
      .patch('CDS-API', `/${path}`, { body, headers });
  },
  delete(path, data) {
    return API
      .del('CDS-API', `/${path}`, { body: data });
  },
};
